import requests from '@/utils/requests';

/**
 * 生成质效看板数据
 * @param {*} data
 */
export function noticeboardGgenerate(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/data/noticeboard/generate',
    method: 'post',
    data
  });
}

/**
 * 质效看板列表
 * @param {*} data
 */
export function noticeboardList(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/data/noticeboard/list',
    method: 'post',
    data
  });
}

/**
 * 质效看板详情
 * @param {*} data
 */
export function noticeboardDetail(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/data/noticeboard/detail',
    method: 'post',
    data
  });
}

/**
 * 添加质效看板
 * @param {*} data
 */
export function noticeboardAdd(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/data/noticeboard/add',
    method: 'post',
    data
  });
}

/**
 * 编辑质效看板
 * @param {*} data
 */
export function noticeboardEdit(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/data/noticeboard/edit',
    method: 'post',
    data
  });
}

/**
 * 删除质效看板
 * @param {*} data
 */
export function noticeboardDelete(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/data/noticeboard/delete',
    method: 'post',
    data
  });
}

/**
 * 删除质效看板
 * @param {*} data
 */
export function noticeboardSendMessage(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/data/noticeboard/sendMessage',
    method: 'post',
    data
  });
}

/**
 * 添加修复数据
 * @param {*} data
 */
export function dataCorrectionAdd(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/data/correction/add',
    method: 'post',
    data
  });
}

/**
 * 删除修复数据
 * @param {*} data
 */
export function dataCorrectionDelete(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/data/correction/delete',
    method: 'post',
    data
  });
}

/**
 * 修改修复数据
 * @param {*} data
 */
export function dataCorrectionModify(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/data/correction/modify',
    method: 'post',
    data
  });
}

/**
 * 发起修复数据申请
 * @param {*} data
 */
export function dataCorrectionApply(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/data/correction/apply',
    method: 'post',
    data
  });
}

/**
 * 获取周期内工作量
 * @param {*} data
 */
export function getDevWorkChart(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/data/diagram/getDevWorkChart',
    method: 'post',
    data
  });
}

/**
 * 获取周期内工作量详情
 * @param {*} data
 */
export function getDevWorkInfoDetail(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/data/diagram/getWorkInfo',
    method: 'post',
    data
  });
}
